import { OrderNotificationContract } from 'hooks/useOrderNotification/OrderNotificationContract'
import { Subject } from 'rxjs'

export enum OrderEventType {
    OnReceiveOrder,
    OnOrderStatusChanged,
    OnOrderPaymentStatusChanged,
}

export interface OrderEventArg {
    type: OrderEventType
    params: OrderNotificationContract
}

const orderEvent = new Subject<OrderEventArg>()

export default orderEvent
